module.exports = "<div *ngIf=\"frameworkConfigService.showUserControls\">\n    <span class=\"sign-out\" (click)=\"signOut()\">Uitloggen</span>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./Scripts/fw/top-bar/top-bar.component.html
// module id = 1863
// module chunks = 1